import { REMOTE_PERMISSIONS } from '@backrs_ui/common-ui';

import { useFetchUserPermissionsQuery } from '@backrs_ui/grow-ui/src/redux/user/user.api';

/** Who the home page renders for. */
export type HomeAudience = 'STUDENT' | 'COACH' | 'INSTITUTION_ADMIN';

/** Null while permissions load, so an admin isn't briefly shown the student home. */
export const useHomeAudience = (): HomeAudience | null => {
  const { data: userPermissions, isLoading } = useFetchUserPermissionsQuery(undefined);

  if (isLoading) return null;

  // An admin holds the analytics permission too, so the admin reading comes first.
  if (userPermissions?.[REMOTE_PERMISSIONS.MANAGE_INSTITUTION_MEMBERS]?.allowed) {
    return 'INSTITUTION_ADMIN';
  }

  return userPermissions?.[REMOTE_PERMISSIONS.ACCESS_COHORT_ANALYTICS]?.allowed
    ? 'COACH'
    : 'STUDENT';
};
